import React from 'react';
import { Typography, Button } from 'antd';
import { Table } from '@yuhuinc/ui-library';
import { DownloadOutlined } from '@ant-design/icons';

const { Title } = Typography;

const ADDENDA_DOC_COLUMNS = [
  {
    title: 'Name',
    key: 'name',
    dataIndex: 'name',
    width: '55%',
  },
  {
    title: 'Start date',
    key: 'startDate',
    dataIndex: 'startDate',
    width: '20%',
  },
  {
    title: 'End date',
    key: 'endDate',
    dataIndex: 'endDate',
    width: '20%',
  },
  {
    key: 'actions',
    width: '5%',
    render() {
      return <Button type="link" icon={<DownloadOutlined />} />;
    },
  },
];

const DUMMY_ADDENDA_DOCS = [
  {
    key: 1,
    name: 'Standard addendum',
    startDate: '2022-09-01',
    endDate: '2023-08-01',
  },
  {
    key: 2,
    name: 'Parking space',
    startDate: '2022-09-01',
    endDate: '2023-08-01',
  },
  {
    key: 3,
    name: 'Bike rack',
    startDate: '2022-09-01',
    endDate: '2023-08-01',
  },
];

const Addenda = () => {
  return (
    <>
      <Title level={4}>Addenda</Title>

      <Table
        dataSource={DUMMY_ADDENDA_DOCS}
        columns={ADDENDA_DOC_COLUMNS}
        hideActionAndSearch
        size={'middle'}
        pagination={{ hideOnSinglePage: true }}
      />
    </>
  );
};

export default Addenda;
